import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MasterContactAddress } from './models/MasterContactAddress';
import { AddressDetailModel } from './models/AddressDetailModel';

@Injectable({
  providedIn: 'root'
})
export class MasterContactService {

  constructor(private http$: HttpClient) { }

  getMasterContactAddresses(searchTerm: string) {
    return this.http$.get<MasterContactAddress[]>('/api/mastercontact/addresses', { params: { searchTerm }, headers: { 'skip-loading': 'true' } });
  }

  getMasterContactById(id: number) {
    return this.http$.get<MasterContactAddress>(`/api/mastercontact/${id}`);
  }

  getFormatedMasterContactAddress(addressDetails: AddressDetailModel) {
    return this.http$.post<string>('/api/mastercontact/formatAddressComponents', addressDetails);
  }
}
